import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { TextNoTranform } from "share-components/atomics/text-no-tranform";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const MaterialInformationTable = observer(() => {
  const {
    productManagement: { productDetail },
  } = useStores();

  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell rowSpan={2}>Loại giấy</TableCell>
          <TableCell rowSpan={2}>Hiệu giấy</TableCell>
          <TableCell rowSpan={2}>Đặt chuẩn</TableCell>
          <TableCell align="center" colSpan={3}>
            GSM <TextNoTranform>(gram)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Độ dầy <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell align="center" colSpan={3}>
            Độ trắng (%)
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
          <TableCell>Chuẩn</TableCell>
          <TableCell>Trên</TableCell>
          <TableCell>Dưới</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{productDetail?.material?.paperType}</TableCell>
          <TableCell>{productDetail?.material?.paperBrand || ""}</TableCell>
          <TableCell>{productDetail?.material?.standard || ""}</TableCell>
          <TableCell>{productDetail?.material?.gsmStandardDisplay}</TableCell>
          <TableCell>
            {productDetail?.material?.gsmUpperWithFactorPercentDisplay
              ? `${productDetail?.material?.gsmUpperWithFactorPercentDisplay}`
              : ""}
          </TableCell>
          <TableCell>
            {productDetail?.material?.gsmLowerWithFactorPercentDisplay
              ? `${productDetail?.material?.gsmLowerWithFactorPercentDisplay}`
              : ""}
          </TableCell>
          <TableCell>
            {productDetail?.material?.thicknessStandardDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.material?.thicknessUpperWithFactorPercentDisplay
              ? `${productDetail?.material?.thicknessUpperWithFactorPercentDisplay}`
              : ""}
          </TableCell>

          <TableCell>
            {productDetail?.material?.thicknessLowerWithFactorPercentDisplay
              ? `${productDetail?.material?.thicknessLowerWithFactorPercentDisplay}`
              : ""}
          </TableCell>
          <TableCell>
            {productDetail?.material?.whitenessStandardDisplay}
          </TableCell>
          <TableCell>
            {productDetail?.material?.whitenessUpperWithFactorPercentDisplay
              ? `${productDetail?.material?.whitenessUpperWithFactorPercentDisplay}`
              : ""}
          </TableCell>

          <TableCell>
            {productDetail?.material?.whitenessLowerWithFactorPercentDisplay
              ? `${productDetail?.material?.whitenessLowerWithFactorPercentDisplay}`
              : ""}
          </TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
